<template>
    <div class="elWrap" ref="leftMenu" :class="{'darkTheme' : state.dark}" style="height: 100%" @wheel.prevent="wheelClick($event)">
        <!-- Поле фильтрации -->
        <!-- <div class="filter-container" style="padding: 8px; border-bottom: 1px solid #eee;">
            <input 
                v-model="filterText"
                @input="handleFilterInput"
                placeholder="Table filter..."
                class="filter-input"
                style="width: 100%; padding: 4px; border: 1px solid #ccc; border-radius: 3px;"
            />
        </div> -->
        <div style="margin: 0;padding-top: 0;padding-right:0; flex-grow: 1;">
            <div v-for="it,ind in arrMenu" v-bind:key="it.name + ind">
                <div :class="['treerow ' + it.type, it && it.choseEl ? 'clkEl' : '']" v-on:click="clickEem(it,ind)" @contextmenu.prevent="getDbName(it), showCntx($event,it)">
                    <!-- <span :class="classGet(it)">{{it.name}} {{it.port}} </span>
                    <span v-if="it.type == 'lvl2'">({{it.childs.length}})</span>
                    <span v-if="it.type == 'lvl4' && it.name === 'Columns'">({{it.expandedY - 1}})</span>
                    <span v-if="it.type == 'lvl4' && it.name === 'Indices' ">({{it.childs.length}})</span>
                    <span v-if="it.type == 'lvl5' && it.fld" class="db otherinfo"> {{ typePrecision(it.fld) }}</span>                             
                    <div v-if="it.type == 'lvl2'" slot="contextmenu" style="z-index:8"></div>
                    <div v-if="it.type == 'lvl3'" slot="contextmenu" style="z-index:8"></div>
                    <div v-if="it.type == 'lvl4' && it.name == 'Indices'" slot="contextmenu" style="z-index:8"></div>
                     <div v-if="it.type == 'lvl5' && it.parent.name == 'Indices'" slot="contextmenu" style="z-index:8"></div> 
                    <div v-if="it.type == 'lvl5' && it.parentType == 'lvl4' && getParentName(it) == 'Indices'" slot="contextmenu" style="z-index:8"></div>
                    <div v-if="it.type == 'lvl5' && it.parentType == 'lvl4' && getParentName(it) == 'Columns'" slot="contextmenu" style="z-index:8"></div>
                    <span v-if="it.type == 'lvl6'" class="db otherinfo"></span> -->
                    <span :class="classGet(it)">{{it.name}} {{it.port}} </span>
                    <span v-if="it.type == 'lvl2'">({{it.childs ? it.childs.length : 0}})</span>
                    <span v-if="it.type == 'lvl4' && it.name === 'Columns'">({{it.expandedY ? it.expandedY - 1 : 0}})</span>
                    <span v-if="it.type == 'lvl4' && it.name === 'Indices'">({{it.childs ? it.childs.length : 0}})</span>
                    <span v-if="it.type == 'lvl5' && it.fld" class="db otherinfo"> {{ typePrecision(it.fld) }}</span>                             

                    <!-- Context menus -->
                    <div v-if="it.type == 'lvl2'" slot="contextmenu" style="z-index:8"></div>
                    <div v-if="it.type == 'lvl3'" slot="contextmenu" style="z-index:8"></div>
                    <div v-if="it.type == 'lvl4' && it.name == 'Indices'" slot="contextmenu" style="z-index:8"></div>

                    <!-- ЗАМЕНИ getParentName на более эффективные проверки -->
                    <div v-if="it.type == 'lvl5' && it.parentType == 'lvl4' && isIndicesChild(it)" slot="contextmenu" style="z-index:8"></div>
                    <div v-if="it.type == 'lvl5' && it.parentType == 'lvl4' && isColumnsChild(it)" slot="contextmenu" style="z-index:8"></div>

                    <span v-if="it.type == 'lvl6'" class="db otherinfo"></span>
                </div>
            </div>
        </div>
        <v-menu v-model="showMenu" :position-x="x" :position-y="y" absolute offset-y>
            <v-list density="compact">
                <v-list-item
                    v-for="(item, index) in items"
                    density="compact"                    
                    :key="index"
                    :value="index"
                    :max-height="20"
                    :min-height="20"
                    :height="20"
                    @click.native.stop="clicCtxMenu(item)"                                       
                >
                    <v-list-item-title>{{ item }}</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
        <!-- <JqxScrollBar v-show="elNum > itemShowEnd" -->
        <JqxScrollBar v-show="shouldShowScrollbar"
            ref="scrollbar"
            @valueChanged="onValueChanged($event)"            
            :width="width"
            :height="scrollHeight"
            :min="min"
            :max="maxScroll"
            :vertical="true"
            :indexThumb="scrollPos"
            class="jqx-scrollbar-thumb-state-normal-new"            
            :key="scrollKey"
            style="position: absolute; top: 0; right: 2px;"/>
    </div>
</template>
  
<script>
import { commonMixin } from '../common.js'
import JqxScrollBar from "jqwidgets-scripts/jqwidgets-vue/vue_jqxscrollbar.vue";
export default {
    mixins: [commonMixin],
    components: {
        JqxScrollBar
    },
    props: {
        state: {
            required: true,
            type: Object
        },
        heightS: {
            required: true,
            type: Number
        }
    },
    data: () => ({
        filterText: "",
        isFiltering: false,       
        scrollPos: 0,
        scrollPosOld: -1,
        itemShowBegin: 0,
        itemShowBeginOld: -1,
        arrMenu: [],
        elNum : 0,
        itemShowEnd: null,
        min: 0,
        max: 0,
        scrollKey: 0,
        width: 8,
        height: null,
        showMenu: false,
        x: 0,
        y: 0,
        items: [],
        expandedStateKey: 0,
        itemsLvl1: [
            'Refresh',
            'Stop',
            'Start',
            'Backup',
            'Restore',
            'Delete',
            // 'Monitoring',
            'Database info',
        ],
        itemsLvl2: [
            'Create',
        ],
        itemsLvl3: [
            'Select top 1000',
            'Modify structure',
            'Create table',
            'Delete',
        ],
        itemsLvl5: [
            'Delete',
        ],
        cldEl: null,
        elemClicked: null,
        filterTimeout: null,
        _scrollTimeout: null,
    }),
    computed: {
        shouldShowScrollbar() {
            // Не показывать если нет видимой области
            if (this.itemShowEnd <= 0) {
                // console.log('shw1 - no visible area', this.elNum, this.itemShowEnd);
                return false;
            }            
            if (this.isFiltering && this.filterText.trim() !== '') {
                // console.log('shw2 - filtering', this.elNum, this.itemShowEnd);
                return this.elNum > this.itemShowEnd;
            } else {
                // console.log('shw3 - normal mode', this.elNum, this.itemShowEnd);
                return this.elNum > this.itemShowEnd;
            }
        },
        
        maxScroll() {
            // console.log('maxScroll');
            if (this.isFiltering && this.filterText.trim() !== '') {
                return this.getFilteredMaxScroll();
            } else {
                const trigger = this.expandedStateKey;
                
                // Считаем ВСЕ элементы которые МОГУТ БЫТЬ показаны (вся раскрытая иерархия)
                const totalPossibleRows = this.calculateTotalPossibleRows();
                const totalHeight = totalPossibleRows * 20;
                // const maxScroll = Math.max(0, totalHeight - this.heightS) + 20;
                
                 // Детальная отладка высот
                // console.log('=== HEIGHT DEBUG ===');
                // console.log('totalPossibleRows:', totalPossibleRows);
                // console.log('totalHeight:', totalHeight);
                // console.log('this.heightS:', this.heightS);
                // console.log('window.innerHeight:', window.innerHeight);
                // console.log('document.documentElement.clientHeight:', document.documentElement.clientHeight);
                
                // Проверим реальную высоту контейнера
                const container = this.$el;
                // console.log('container.offsetHeight:', container?.offsetHeight);
                // console.log('container.clientHeight:', container?.clientHeight);
                
                const maxScroll = Math.max(0, totalHeight - this.heightS) + 20;
                
                // console.log('calculated maxScroll:', maxScroll);
                // console.log('====================');
                // console.log('scrollbar', this.$refs.scrollbar);
                
                return maxScroll;
            }
        },

        scrollHeight() {
            this.itemShowEnd = Math.floor(this.heightS/20)            
            return this.heightS
        },
        scrollLeft() {
            // console.log('scrollPos() ',this.$refs.scrollbar);                
            return window.innerWidth - this.state.gridWidth
        }        
    },
    watch: {
    'state.height'() {
        this.height = window.innerHeight - 29 - 40 - 2
        this.itemShowEnd = Math.floor((this.height)/20)         
        if(this.elNum <= this.itemShowEnd) this.itemShowBegin = 0
        this.getArr()
        this.scrollKey++
        this.$refs.scrollbar.setPosition(this.scrollPos);
    },
    // Добавьте этот watch для отслеживания изменений в структуре меню
    'state.menuList2': {
        handler() {
            // console.log('Menu structure changed, recalculating maxScroll');
            // Форсируем пересчет maxScroll
            this.expandedStateKey++;
            this.$nextTick(() => {
                if (this.$refs.scrollbar) {
                    // this.scrollKey++
                    // this.$refs.scrollbar.setPosition(this.scrollPos);
                }
            });
        },
        deep: true // Следим за глубокими изменениями
    }
    },
    mounted() {
        this.height = window.innerHeight - 30 - 40
        // console.log('mounted',window.innerHeight);
        // console.log('mounted',window.innerHeight - 30 - 40);
        
        this.itemShowEnd = Math.floor((this.height)/20)  
                  
        // setInterval(()=>{
        //     // console.log('mount scroll');
        //     this.getArr(1)
        // },100)

        this.getArr() // один раз при монтировании
        this.$watch(
            () => this.state.menuList2.length, // следим только за длиной
            () => {
                this.$nextTick(() => {
                    this.getArr()
                })
            }
        )
    },
    methods: {
        // Метод для подсчета ВСЕХ элементов в обычном режиме
        calculateTotalElements() {
            let totalCount = 0;
            
            const countAll = (items) => {
                if (!items || !Array.isArray(items)) return;
                
                for (const item of items) {
                    if (!item) continue;
                    
                    totalCount++;
                    
                    // Считаем дочерние элементы ТОЛЬКО если родитель раскрыт
                    if (item.expanded && item.childs && Array.isArray(item.childs)) {
                        countAll(item.childs);
                    }
                }
            };
            
            countAll(this.state.menuList2);
            return totalCount;
        },
        // Находит оригинальный элемент по фильтрованной копии
        findOriginalElement(filteredElement) {
            if (!filteredElement) return null;
            
            // Для lvl1 элементов ищем по port
            if (filteredElement.type === 'lvl1') {
                return this.state.menuList2.find(db => 
                    db.port === filteredElement.port && 
                    db.name === filteredElement.name
                );
            }
            
            // Для других элементов рекурсивно ищем по структуре
            const findInStructure = (items) => {
                for (const item of items) {
                    if (!item) continue;
                    
                    // Сравниваем по ключевым свойствам
                    if (item.type === filteredElement.type && 
                        item.name === filteredElement.name &&
                        item.port === filteredElement.port &&
                        item.parentId === filteredElement.parentId) {
                        return item;
                    }
                    
                    if (item.childs && Array.isArray(item.childs)) {
                        const found = findInStructure(item.childs);
                        if (found) return found;
                    }
                }
                return null;
            };
            
            return findInStructure(this.state.menuList2);
        },
        isIndicesChild(item) {
            // Быстрая проверка без поиска родителя
            if (!item || !item.parentId) return false;
            
            // parentId имеет формат: "port_table_indices" для индексов
            // или "port_table_columns" для колонок
            return item.parentId.includes('_indices');
        },
        isColumnsChild(item) {
            if (!item || !item.parentId) return false;
            return item.parentId.includes('_columns');
        },
        // Или универсальный метод:
        getParentNodeType(item) {
            if (!item || !item.parentId) return '';
            
            if (item.parentId.includes('_indices')) return 'Indices';
            if (item.parentId.includes('_columns')) return 'Columns';
            if (item.parentId.includes('_tables')) return 'Tables';
            
            return '';
        },
        getParentName(item) {
            if (!item || !item.parentId) return '';
            // Находим родителя по parentId и возвращаем его имя
            const parent = this.findParentById(item.parentId, item.parentType);
            return parent ? parent.name : '';
        },
        getFilteredMaxScroll() {
            const searchText = this.filterText.trim().toLowerCase();
            const filteredStructure = this.buildFilteredStructure(searchText);
            
            // Используем правильный подсчет для фильтрованных элементов
            const totalElements = this.countFilteredElements(filteredStructure);
            const totalHeight = totalElements * 20;
            const visibleHeight = this.heightS - 46.5; // Высота контейнера минус поле фильтра
            
            const maxScroll = Math.max(0, totalHeight - visibleHeight);
            
            // console.log('🎯 Filtered maxScroll calculation:', { 
            //     totalElements,
            //     totalHeight,
            //     visibleHeight,
            //     maxScroll,
            //     itemShowEnd: this.itemShowEnd
            // });
            
            return maxScroll;
        },
        countFilteredElements(filteredStructure) {
            let count = 0;
            
            const countItems = (items) => {
                if (!items || !Array.isArray(items)) return;
                
                for (const item of items) {
                    if (!item) continue;
                    count++;
                    
                    // console.log(`Counting: ${item.type} ${item.name} - expanded: ${item.expanded}, count: ${count}`);
                    
                    // Считаем дочерние элементы ТОЛЬКО если родитель раскрыт
                    if (item.expanded && item.childs && Array.isArray(item.childs)) {
                        countItems(item.childs);
                    }
                }
            };
            
            countItems(filteredStructure);
            
            // console.log('🎯 FINAL Filtered elements count:', count);
            // console.log('📊 Filtered structure summary:', {
            //     databases: filteredStructure.length,
            //     tables: filteredStructure.reduce((acc, db) => acc + (db.childs?.[0]?.childs?.length || 0), 0),
            //     totalCount: count
            // });
            
            return count;
        },
        handleFilterInput() {
            const searchText = this.filterText.trim().toLowerCase();

            // Дебаунс 300ms для производительности
            if (this.filterTimeout) {
                clearTimeout(this.filterTimeout);
            }
            
            // this.filterTimeout = setTimeout(() => {
                if (searchText === '') {
                    this.isFiltering = false;
                    this.scrollPos = 0;
                    this.itemShowBegin = 0;
                    this.getArr();
                } else {
                    this.isFiltering = true;
                    this.scrollPos = 0;
                    this.itemShowBegin = 0;
                    this.applyFilter(searchText);
                }
                
                this.$nextTick(() => {
                    if (this.$refs.scrollbar) {
                        this.$refs.scrollbar.setPosition(0);
                    }
                });
            // }, 100);
        },
        applyFilter(searchText) {
            console.log('applyFilter');
            
            // СОХРАНЯЕМ текущую позицию скролла
            const currentScrollPos = this.scrollPos;
            
            // Убедимся что есть текст для поиска
            if (!searchText) {
                this.isFiltering = false;
                // this.scrollPos = 0;
                // this.itemShowBegin = 0;
                this.getArr();
            } else {
                this.isFiltering = true;
                // this.scrollPos = 0;
                // this.itemShowBegin = 0;
                
                const filteredStructure = this.buildFilteredStructure(searchText);
                this.renderFilteredMenu(filteredStructure);
            }
            
            this.scrollKey++;
            this.$nextTick(() => {
                if (this.$refs.scrollbar) {
                    // ВОССТАНАВЛИВАЕМ позицию скролла для фильтрации (или 0 если новый поиск)
                    this.$refs.scrollbar.setPosition(currentScrollPos);
                    this.scrollPos = currentScrollPos;
                }
            });
        },
        // Оптимизированный buildFilteredStructure
        buildFilteredStructure(searchText) {
            if (!searchText) {
                return this.state.menuList2;
            }
            
            const filteredStructure = [];
            
            for (const db of this.state.menuList2) {
                // Проверяем, есть ли в этой БД таблицы, соответствующие фильтру
                let hasMatchingTables = false;
                
                if (db.childs && db.childs[0] && db.childs[0].childs) {
                    const originalTables = db.childs[0].childs;
                    
                    for (const table of originalTables) {
                        if (table.name.toLowerCase().includes(searchText)) {
                            hasMatchingTables = true;
                            break;
                        }
                    }
                }
                
                if (hasMatchingTables) {
                    // Создаем копию БД с сохранением состояния expanded
                    const dbCopy = { 
                        ...db,
                        // Используем существующее состояние, если оно есть, иначе true (первое применение фильтра)
                        expanded: db.expanded !== undefined ? db.expanded : true,
                        childs: db.childs ? [...db.childs] : undefined
                    };
                    
                    if (dbCopy.childs && dbCopy.childs[0] && dbCopy.childs[0].childs) {
                        const tablesNode = dbCopy.childs[0];
                        const originalTables = db.childs[0].childs;
                        
                        // Фильтруем таблицы по поисковому запросу
                        const filteredTables = originalTables
                            .filter(table => table.name.toLowerCase().includes(searchText))
                            .map(originalTable => {
                                return {
                                    ...originalTable,
                                    expanded: originalTable.expanded !== undefined ? originalTable.expanded : false,
                                    childs: originalTable.childs ? originalTable.childs.map(child => ({
                                        ...child,
                                        expanded: child.expanded !== undefined ? child.expanded : false
                                    })) : undefined
                                };
                            });
                        
                        // Обновляем узел Tables
                        const filteredTablesNode = {
                            ...tablesNode,
                            // Используем существующее состояние, если оно есть, иначе true
                            expanded: tablesNode.expanded !== undefined ? tablesNode.expanded : true,
                            childs: filteredTables
                        };
                        
                        dbCopy.childs = [filteredTablesNode];
                        filteredStructure.push(dbCopy);
                        
                        // console.log('DB in filtered structure:', {
                        //     name: dbCopy.name,
                        //     lvl1Expanded: dbCopy.expanded,
                        //     lvl2Expanded: filteredTablesNode.expanded,
                        //     tablesCount: filteredTables.length
                        // });
                    }
                }
            }
            
            return filteredStructure;
        },
        // Рендерит отфильтрованное меню
        renderFilteredMenu(filteredStructure) {
            const currentScrollPos = this.scrollPos;
            
            let elNum = 0;
            const arr = [];
            
            // Рендерим только видимую область
            const processItems = (items, level = 0) => {
                if (!items || !Array.isArray(items)) return;
                
                for (const item of items) {
                    if (!item) continue;
                    
                    if (elNum >= this.itemShowBegin + this.itemShowEnd) break;
                    
                    if (elNum >= this.itemShowBegin) {
                        arr.push(item);
                        
                        // Отладочная информация
                        // if (item.type === 'lvl3' || item.type === 'lvl4') {
                        //     console.log(`Rendering: ${'  '.repeat(level)}${item.type} ${item.name} - expanded: ${item.expanded}`);
                        // }
                    }
                    elNum++;
                    
                    if (item.expanded && item.childs && Array.isArray(item.childs)) {
                        processItems(item.childs, level + 1);
                    }
                }
            };
            
            if (filteredStructure && Array.isArray(filteredStructure)) {
                processItems(filteredStructure);
            }
            
            this.arrMenu = arr;
            this.elNum = this.countFilteredElements(filteredStructure);
            
            // console.log('Filtered render result:', {
            //     arrMenuItems: arr.length,
            //     totalElNum: this.elNum,
            //     itemShowBegin: this.itemShowBegin
            // });
        },
        updateScrollbar() {
            this.$nextTick(() => {
                if (this.$refs.scrollbar) {
                    // Обновляем скроллбар без пересоздания
                    this.$refs.scrollbar.refresh();
                    
                    // Сохраняем текущую позицию
                    const currentPos = this.$refs.scrollbar.value;
                    
                    // Если позиция была в конце, остаемся в конце
                    if (this._wasAtEnd) {
                        this.$refs.scrollbar.setPosition(this.maxScroll);
                        this.scrollPos = this.maxScroll;
                        this.itemShowBegin = Math.floor(this.maxScroll / 20);
                    }
                }
            });
        },
        calculateTotalPossibleRows() {
            return this.calculateTotalElements();
        },
        menuContex(item) {
            // console.log('menuContex',item);            
            // console.log('menuContex2',this.cldEl);
            let bool 
            switch (item) {
                case 'Stop':
                    if (this.cldEl.run) {
                        bool = true     
                    } else {
                        bool = false
                    }
                    break;
                case 'Start':
                    if (this.cldEl.run) {
                        bool = false     
                    } else {
                        bool = true
                    }
                    break;
            
                default:
                    bool = true
                    break;
            }
            return bool
        },
        wheelClick(e){
            // console.log('wheelClick',this.$refs.scrollbar.value); 
            // console.log('wheelClick2',this.$refs.scrollbar.value); 
            // Используем shouldShowScrollbar вместо elNum > itemShowEnd
            if(!this.shouldShowScrollbar) return;
            if (e.deltaY > 0) {
                this.$refs.scrollbar.setPosition(this.$refs.scrollbar.value + this.$refs.scrollbar.step);           
            } else {
                this.$refs.scrollbar.setPosition(this.$refs.scrollbar.value - this.$refs.scrollbar.step);           
            }
            this.$nextTick(() => {
                this.getArr()
            })
        },
        showCntx(e, el) {
            //console.log('showCntx', el);
            this.cldEl = el
            
            // Сначала определяем БД
            this.getDbName(el)
            
            switch (el.type) {
                case 'lvl1':
                    let arr = [
                        'Refresh', 'Stop', 'Start', 'Backup', 'Restore', 'Delete', 'Database info',
                    ]                                      
                    if (el.run) {
                        arr.splice(2, 1);
                    } else {
                        arr.splice(1, 1);
                    }
                    this.items = arr
                    break;
                case 'lvl2':
                    this.items = this.itemsLvl2
                    break;
                case 'lvl4':
                    if (el.name === 'Indices') {
                        this.items = this.itemsLvl2                        
                    } else {
                        return
                    }
                    break;
                case 'lvl3':
                    this.items = this.itemsLvl3
                    break;
                case 'lvl5':
                    // Временно используем старый подход для parent
                    if (el.parentType === 'lvl4' && this.isIndicesChild(el)) {                  
                        this.items = this.itemsLvl5
                    } else {
                        return
                    }
                    break;
                default:
                    this.items = []
                    return
            }
            
            e.preventDefault();
            this.showMenu = false;
            this.x = e.clientX;
            this.y = e.clientY;
            this.$nextTick(() => {
                this.showMenu = true;
            });
        },       
        clickEem(el, ind) {
            if (this.elemClicked) {
                this.elemClicked.choseEl = false;
            }
            el.choseEl = true;            
            this.elemClicked = el;
            
            if (el.type === 'lvl6') return;
            
            const currentScrollPos = this.scrollPos;

            if (el.type === 'lvl1') {
                if (!el.run) return;
                let db = this.state.dblist.find(elem => elem.port == el.port);
                this.SetActiveDb(db);
                
                if (this.isFiltering) {
                    // ДЛЯ LVL1 В РЕЖИМЕ ФИЛЬТРАЦИИ
                    el.expanded = !el.expanded;
                    
                    // Также обновляем оригинал для сохранения состояния
                    const originalEl = this.findOriginalElement(el);
                    if (originalEl) {
                        originalEl.expanded = el.expanded;
                    }
                    // Перестраиваем фильтр с учетом нового состояния
                    this.applyFilter(this.filterText.trim().toLowerCase());
                    
                } else {
                    // Обычная логика для lvl1 БЕЗ фильтрации
                    if (!el.childs) {                    
                        this.LoadDbFromServer(el);
                        el.expanded = !el.expanded;
                        return;
                    }
                    el.expanded = !el.expanded;
                    this.scheduleSingleUpdate(el);
                }
            } else {
                this.getDbName(el);
                if (el.hasOwnProperty('fld')) return;
                
                if (this.isFiltering) {
                    el.expanded = !el.expanded;
                    
                    const originalEl = this.findOriginalElement(el);
                    if (originalEl) {
                        originalEl.expanded = el.expanded;
                    }
                    this.applyFilter(this.filterText.trim().toLowerCase());
                } else {
                    el.expanded = !el.expanded;
                    this.expandedStateKey++;
                    this.getArr();
                }
            }
            
            this.scrollKey++; 
            this.$nextTick(() => {
                if (this.$refs.scrollbar) {
                    this.$refs.scrollbar.setPosition(currentScrollPos);
                    this.scrollPos = currentScrollPos;
                }
            });
        },  
        // Замена интервала - ОДИН вызов getArr
        scheduleSingleUpdate(el) {
            // СОХРАНЯЕМ текущую позицию скролла
            const currentScrollPos = this.scrollPos;
            // console.log('Schedule update - saving scroll position:', currentScrollPos);
            
            let intr = setInterval(() => {
                if (el.childs) {                        
                    clearInterval(intr)
                    el.y = el.expanded ? el.expandedY : 1
                    
                    this.expandedStateKey++; 
                    this.getArr()
                    this.scrollKey++
                    this.$nextTick(() => {
                        if (this.$refs.scrollbar) {
                            // ВОССТАНАВЛИВАЕМ сохраненную позицию скролла
                            // console.log('Schedule update - restoring scroll to:', currentScrollPos);
                            this.$refs.scrollbar.setPosition(currentScrollPos);
                            this.scrollPos = currentScrollPos;
                        }
                    })                  
                }
            }, 10)
        },
        SetActiveDb(db){
            this.state.active_db = db;
            this.state.menudb =db.dbname;
            // db.loaded = false
        },        
        // Обновленный getArr БЕЗ интервала
        getArr(param) {
            // console.log('getArr')
            // ('=== GET ARR CALLED ===');
            // console.log('Current scrollPos:', this.scrollPos);
            // console.log('itemShowBegin:', this.itemShowBegin);
            // Проверяем что фильтр действительно активен
            // if (this.isFiltering && this.filterText.trim() !== '') {
            //     const searchText = this.filterText.trim().toLowerCase();
            //     const filteredStructure = this.buildFilteredStructure(searchText);
            //     this.renderFilteredMenu(filteredStructure);
            //     return;
            // }
            
            // Стандартная логика без фильтрации
            if (param !== undefined && this.scrollPos === this.scrollPosOld && 
                this.itemShowBegin === this.itemShowBeginOld) {
                return;
            }
            console.log('getArr')
            this.scrollPosOld = this.scrollPos;
            this.itemShowBeginOld = this.itemShowBegin;
            
            const first = this.itemShowBegin;
            const all = this.itemShowEnd;
            let elNum = 0;
            const arr = [];
            
            // console.log('=== GET ARR (NORMAL) ===');
            // console.log('first:', first, 'all:', all);
            
            // Рендерим только видимую область
            const renderVisible = (items) => {
                if (!items || !Array.isArray(items)) return;
                
                for (const item of items) {
                    if (!item) continue;
                    
                    if (elNum >= first + all) return;
                    
                    if (elNum >= first) {
                        arr.push(item);
                    }
                    elNum++;
                    
                    if (item.expanded && item.childs && Array.isArray(item.childs)) {
                        renderVisible(item.childs);
                        if (elNum >= first + all) return;
                    }
                }
            };
            
            renderVisible(this.state.menuList2);
            
            this.arrMenu = arr;
           
            // ВАЖНО: используем calculateTotalElements для общего количества
            this.elNum = this.calculateTotalElements();
        },        

        getDbName(obj) {
            // console.log('getDbName called for:')            
            // Для lvl1 элементов
            if (obj.type === 'lvl1') {
                this.state.menudb = obj.name
                let db = this.state.dblist.find(el => el.port === obj.port)
                this.SetActiveDb(db)
                return
            }
            
            // Для других элементов ищем родительскую БД
            let current = obj
            while (current && current.type !== 'lvl1') {
                if (current.parentId && current.parentType === 'lvl1') {
                    const parent = this.findParentById(current.parentId, current.parentType)
                    if (parent) {
                        this.state.menudb = parent.name
                        let db = this.state.dblist.find(el => el.port === parent.port)
                        this.SetActiveDb(db)
                        return
                    }
                }
                
                // Переходим к следующему родителю
                if (current.parentId) {
                    current = this.findParentById(current.parentId, current.parentType)
                } else {
                    break
                }
            }
            
            // console.warn('getDbName: could not find database for', obj.name)
        },
        // Вспомогательные методы для работы с новой структурой
        // Упрощенный findParentById для всех случаев
        findParentById(parentId, parentType) {
            // console.log('findParentById', parentId, parentType);
            
            if (!parentId) return null
            
            // Для lvl1 ищем в menuList2
            if (parentType === 'lvl1') {
                return this.state.menuList2.find(item => item.port === parentId)
            }
            
            // Для других типов рекурсивно ищем по всей структуре
            return this.findInMenuStructure(parentId)
        },

        // Упрощенный поиск в структуре
        findInMenuStructure(targetId) {
            // console.log('findInMenuStructure',targetId);            
            const search = (items) => {
                for (const item of items) {
                    // Проверяем текущий элемент
                    const itemId = this.getItemId(item)
                    //  console.log('findInMenuStructure search',itemId); 
                    if (itemId === targetId) {
                        return item
                    }
                    
                    // Рекурсивно проверяем дочерние элементы
                    if (item.childs && item.childs.length > 0) {
                        const found = search(item.childs)
                        if (found) return found
                    }
                }
                return null
            }
            
            return search(this.state.menuList2)
        },

        searchInItem(item, targetId) {
            if (this.getItemId(item) === targetId) return item;
            
            if (item.childs) {
                for (const child of item.childs) {
                    const found = this.searchInItem(child, targetId);
                    if (found) return found;
                }
            }
            return null;
        },

        getItemId(item) {
            if (!item) return null
            if (item.parentId && item.type) {
                switch (item.type) {
                    case 'lvl1': return item.port
                    // case 'lvl2': return item.parentId + '_tables'
                    case 'lvl2': return item.parentId 
                    case 'lvl3':
                        
                        return item.parentId + '_' + item.name
                    case 'lvl4': 
                    if (item.name === 'Columns') return item.parentId + '_columns'
                    if (item.name === 'Indices') {
                        // console.log('getItemId 4', item.parentId + '_indices');
                        return item.parentId + '_indices'}
                    return item.parentId + '_' + item.name
                    case 'lvl5': return item.parentId + '_' + item.name
                    default: return item.parentId + '_' + item.name
                }
            }
            return item.port || item.name
        },

        findRootParent(obj) {
            // Находим корневого родителя (БД)
            let current = obj;
            while (current.parentId && current.parentType !== 'lvl1') {
                current = this.findParentById(current.parentId, current.parentType);
                if (!current) break;
            }
            return current;
        },
        // Обновленный updateParentY для работы с parentId
        // Упрощенный updateParentY - только для визуальных свойств
        updateParentY(el, deltaY, isExpanding) {
            if (!el) return;
            
            // console.log('updateParentY visual only:', el.name, 'delta:', deltaY);
            
            // Обновляем ТОЛЬКО expandedY для отображения, но не используем для вычислений
            el.expandedY += deltaY;
            el.expandedY = Math.max(1, el.expandedY);
            
            // y теперь вычисляется динамически на основе expanded состояния
            el.y = el.expanded ? el.expandedY : 1;
            
            // Принудительно обновляем скролл
            this.$nextTick(() => {
                this.scrollKey++;
                this.$refs.scrollbar.setPosition(this.scrollPos);
            });
            
            // Рекурсивно для родителей
            if (el.parentId && el.parentType) {
                const parent = this.findParentById(el.parentId, el.parentType);
                if (parent) {
                    this.updateParentY(parent, deltaY, isExpanding);
                }
            }
        },
        classGet(el) {
            let str = ''
            if (el.type == 'lvl1') {
                if (el.expanded) {
                str += 'db expanded '
                } 
                if (!el.expanded) {
                str += 'db collapsed '
                } 
                //if (!el.port) {
                //  str += 'portBusy '
                //}
                if (!el.run) {
                str += 'stop'
                }
            }
            if (el.type == 'lvl2' || el.type == 'lvl3' || el.type == 'lvl4') {        
                if (el.expanded) {
                str += 'db expanded '
                }
                if (!el.expanded) {
                str += 'db collapsed '
                }
            }
            if (el.type == 'lvl5' && !el.fld) {
                //console.log('class', el)
                if (el.expanded) {
                str += 'db expanded '
                }
                if (!el.expanded) {
                str += 'db collapsed '
                }
            }            
            return str
        },
        typePrecision(fld) {
            // console.log('typePrec1 ',fld);     
            // console.log('typePrec ',fld.type+'-'+fld.scale);     
            let val = ''
            let type = this.typemap[fld.type + '-' + fld.scale]
            
            if (fld.precision != 0 && fld.precision != -1) {
                switch (fld.type) {
                case 12:
                    type= 'decimal'
                    val = ` (${fld.precision},${fld.scale}) `
                    break;
                    
                case 5:
                    type = 'datetime'
                    val = ` (${fld.precision}) `
                    /* 
                    if(fld.precision == 7) {
                    type = 'datetime'
                    val = ` (${fld.precision}) `
                    } else if((fld.precision == 3)) {
                    type = 'datetime'
                    val = ``
                    } else if((fld.precision == 3)) {
                    type = 'datetime'
                    val = ``
                    }
                    */
                    break;

                default:
                    val = ` (${fld.precision}) `
                    break;
                }        
            } else if (fld.precision == -1) {
                val =` (max) `
            } 
            let str =  '[' + type + val + (fld.nullable === 1?'':' NOT')+' NULL' + (fld.defaultvalue ? ` DEFAULTVALUE (${fld.defaultvalue})`: '') +']'||(fld.type+'-'+fld.subtype) + ']' + ' ' + fld.linktable 
            // console.log('str ', str);  
            return str
        },
        onValueChanged(event) {
            // console.log('=== SCROLL POSITION CHANGED ===', this.isFiltering, this.filterText.trim() !== '');
            
            // ОБЩИЕ значения для всех режимов
            this._wasAtEnd = (event.currentValue >= this.maxScroll - 100);
            this.itemShowBegin = Math.floor(event.currentValue / 20);
            this.scrollPos = event.currentValue; // ← ВАЖНО: всегда обновляем!
            
            // console.log('Scroll details:', {
            //     position: this.scrollPos,
            //     itemShowBegin: this.itemShowBegin,
            //     wasAtEnd: this._wasAtEnd
            // });
            
            if (this.isFiltering && this.filterText.trim() !== '') {
                this.handleFilteredScroll();
            } else {
                this.getArr();
            }
        },
        // Обновленный showCntx для работы с оригиналами
        showCntx(e, el) {
            // console.log('showCntx', el);
            this.cldEl = el;
            
            // Используем оригинал для контекстного меню при фильтрации
            const contextEl = this.isFiltering ? this.findOriginalElement(el) || el : el;
            
            this.getDbName(contextEl);
            
            switch (contextEl.type) {
                case 'lvl1':
                    let arr = [
                        'Refresh', 'Stop', 'Start', 'Backup', 'Restore', 'Delete', 'Database info',
                    ];                                      
                    if (contextEl.run) {
                        arr.splice(2, 1);
                    } else {
                        arr.splice(1, 1);
                    }
                    this.items = arr;
                    break;
                case 'lvl2':
                    this.items = this.itemsLvl2;
                    break;
                case 'lvl4':
                    if (contextEl.name === 'Indices') {
                        this.items = this.itemsLvl2;                        
                    } else {
                        return;
                    }
                    break;
                case 'lvl3':
                    this.items = this.itemsLvl3;
                    break;
                case 'lvl5':
                    if (contextEl.parentType === 'lvl4' && this.isIndicesChild(contextEl)) {                  
                        this.items = this.itemsLvl5;
                    } else {
                        return;
                    }
                    break;
                default:
                    this.items = [];
                    return;
            }
            
            e.preventDefault();
            this.showMenu = false;
            this.x = e.clientX;
            this.y = e.clientY;
            this.$nextTick(() => {
                this.showMenu = true;
            });
        },
        /*
        refreshDbList(i) {
            console.log('refreshDbList')
            const arrayFilteredMenuList2 = []
            this.ExecCommand(7,(response) => {
                console.log('refreshDbList response', response.data.list);
                console.log('refreshDbList state', this.state.dblist);
                const array2Copy = [...this.state.dblist];
                // 1. Обновляем существующие элементы и добавляем новые
                response.data.list.forEach(item1 => {
                    const indexInArray2 = array2Copy.findIndex(item2 => item2.dbname === item1.dbname);
                    
                    if (indexInArray2 === -1) {
                        // Элемент отсутствует в array2 - добавляем его
                         array2Copy.push({
                            ...item1,
                            // Для новых элементов добавляем дефолтные значения
                            loaded: false,
                            data: [],
                            indexes: [],
                            version: ''
                        });
                    } else {
                        // Элемент существует - обновляем только свойства из array1
                        const existingItem = array2Copy[indexInArray2];
                        array2Copy[indexInArray2] = {
                            ...existingItem,
                            ...item1
                            // Свойства из array1 перезапишут соответствующие свойства из array2
                        };
                    }
                });
                // 2. Удаляем элементы, которых нет в array1
                const array2Filtered = array2Copy.filter(item2 => {
                    return response.data.list.some(item1 => item1.dbname === item2.dbname);
                });
               
                console.log('refreshDbList',array2Filtered);
                array2Filtered.forEach(el => {
                    arrayFilteredMenuList2.push({
                        name: el.dbname,
                        y: 1,
                        expanded: false,
                        type: 'lvl1',
                        expandedY: 2,
                        choseEl: false,
                        run: el.run,
                        port: el.port,
                        dbpath: el.dbpath
                    })
                })
                 // 3. Эмитим событие для обновления array2 в родительском компоненте
                this.$emit('update-state', array2Filtered, arrayFilteredMenuList2);
            })
        },
        */

        refreshDbList(i) {
            console.log('refreshDbList', this.state.active_db?.dbname)
            
            this.ExecCommand(7, (response) => {
                const serverList = response.data.list;
                
                // Создаем Map для быстрого поиска
                const currentMap = new Map();
                (this.state.dblist || []).forEach(item => {
                    currentMap.set(item.dbname, item);
                });
                
                // Флаги для проверок
                let activeDbExists = true;
                let activeDbIsRunning = true;
                const activeDbName = this.state.active_db?.dbname;
                
                // Проверяем активную базу перед обработкой
                if (activeDbName && !currentMap.has(activeDbName)) {
                    activeDbExists = false;
                }
                
                // Обрабатываем данные с сервера
                serverList.forEach(serverItem => {
                    if (currentMap.has(serverItem.dbname)) {
                        // Обновляем существующий
                        // Проверяем активную базу
                        if (activeDbName === serverItem.dbname) {
                            if (serverItem.run === false) {
                                activeDbIsRunning = false;
                            }
                        }
                        
                        currentMap.set(serverItem.dbname, {
                            ...currentMap.get(serverItem.dbname),
                            ...serverItem
                        });
                    } else {
                        // Добавляем новый
                        currentMap.set(serverItem.dbname, {
                            ...serverItem,
                            loaded: false,
                            data: [],
                            indexes: [],
                            version: ''
                        });
                    }
                });
                
                // Удаляем элементы, которых нет на сервере
                const serverDbNames = new Set(serverList.map(item => item.dbname));
                const array2Filtered = Array.from(currentMap.values())
                    .filter(item => serverDbNames.has(item.dbname));
                
                // Проверяем, осталась ли активная база после фильтрации
                if (activeDbName && !array2Filtered.some(item => item.dbname === activeDbName)) {
                    activeDbExists = false;
                }
                
                // Создаем menuList2
                const arrayFilteredMenuList2 = array2Filtered.map(el => ({
                    name: el.dbname,
                    y: 1,
                    expanded: false,
                    type: 'lvl1',
                    expandedY: 2,
                    choseEl: false,
                    run: el.run,
                    port: el.port,
                    dbpath: el.dbpath
                }));
                
                // console.log('Обновленные данные:', {
                //     dblist: array2Filtered,
                //     menuList2: arrayFilteredMenuList2,
                //     activeDbExists,
                //     activeDbIsRunning
                // });
                
                // Формируем результат
                const result = {
                    dblist: array2Filtered,
                    menuList2: arrayFilteredMenuList2
                };
                
                // Добавляем информацию об активной базе
                if (!activeDbExists) {
                    result.active_db = false; // Сбрасываем активную базу
                    // result.menudb = ''; // Сбрасываем выбранное меню
                } 
                else if (!activeDbIsRunning) {
                    // Можно добавить флаг, что база остановлена
                    result.active_db = false;
                }
                console.log('Обновленные данные:', result);
                this.$emit('update-state', result);
            });
        },
        syncArrays() {
        const array2Copy = [...this.array2];
        
        // 1. Обновляем существующие элементы и добавляем новые
        this.array1.forEach(item1 => {
            const indexInArray2 = array2Copy.findIndex(item2 => item2.dbname === item1.dbname);
            
            if (indexInArray2 === -1) {
            // Элемент отсутствует в array2 - добавляем его
            array2Copy.push({
                ...item1,
                // Добавляем дополнительные свойства из существующего элемента, если они есть
                ...(this.array2.find(item => item.dbname === item1.dbname) || {})
            });
            } else {
            // Элемент существует - обновляем только свойства из array1
            const existingItem = array2Copy[indexInArray2];
            array2Copy[indexInArray2] = {
                ...existingItem,
                ...item1
                // Свойства из array1 перезапишут соответствующие свойства из array2
            };
            }
        });
        
        // 2. Удаляем элементы, которых нет в array1
        const array2Filtered = array2Copy.filter(item2 => {
            return this.array1.some(item1 => item1.dbname === item2.dbname);
        });
        
        // 3. Эмитим событие для обновления array2 в родительском компоненте
        this.$emit('update-array2', array2Filtered);
        },

        clicCtxMenu(item) {
            // console.log('clicCtxMenu 2',item,this.cldEl);
            switch (item) {
                case 'Refresh':
                    // this.dispatch('App','Refresh',this.cldEl)
                    // console.log('clicCtxMenu Refresh',this.state.active_tab.idconnect);
                    // this.getArr()
                    console.log("reresh left menu");
                    this.refreshDbList(item)
                    
                    this.cldEl.expanded = false
                    // this.updateParentY(el.parent, -(el.y - 1), el.expanded)
                    this.LoadDbFromServer(this.cldEl)
                    let intr = setInterval(() => {
                        if (this.cldEl.childs) {                        
                            clearInterval(intr)
                            this.cldEl.y = 1
                            this.cldEl.expandedY = 2
                            // if (!el.expanded) {
                            //     el.y = 1
                            // } else {
                            //     el.y = el.expandedY
                            // }
                            this.getArr()
                            ++this.scrollKey
                        }
                    }, 10)
                    break;
                case 'Stop':
                    this.dispatch('Home','Stop',this.cldEl)
                    // console.log('clicCtxMenu Refresh',this.state.active_tab.idconnect);
                    // this.getArr()
                    break;
                case 'Start':
                    this.dispatch('Home','Start',this.cldEl)
                    // console.log('clicCtxMenu Refresh',this.state.active_tab.idconnect);
                    // this.getArr()
                    break;
                case 'Backup':
                    this.dispatch('Home','Backup',this.cldEl)
                    // console.log('clicCtxMenu Refresh',this.state.active_tab.idconnect);
                    // this.getArr()
                    break;
                case 'Restore':
                    this.dispatch('Home','Restore',this.cldEl)
                    // console.log('clicCtxMenu Refresh',this.state.active_tab.idconnect);
                    // this.getArr()
                    break;
                case 'Delete':
                    if (this.cldEl.hasOwnProperty('port')) {
                        this.dispatch('Home','DeleteDb',this.cldEl)                       
                    }
                    if (this.cldEl.type == 'lvl3') {
                        this.dispatch('Home','DeleteTbl',this.cldEl)               
                    }
                    // console.log('clicCtxMenu lvl5',this.cldEl.type);
                    if (this.cldEl.type == 'lvl5') {
                        console.log('del ind', item, this.state.menuList2);
                        // this.state.menuList2.fo
                        function findTableName(data, element) {
                            function findParent(parentId, currentLevel) {
                                for (const item of currentLevel) {
                                    if (item.id === parentId) {
                                        return item;
                                    }
                                    if (item.childs && item.childs.length > 0) {
                                        const found = findParent(parentId, item.childs);
                                        if (found) return found;
                                    }
                                }
                                return null;
                            }
                            let currentElement = element;
                            while (currentElement) {
                                console.log('findTableName', currentElement);
                                
                                // Если текущий элемент - таблица (lvl3), возвращаем имя таблицы
                                if (currentElement.type === 'lvl3') {
                                    return currentElement.tableData?.tablename || currentElement.name;
                                }
                                // Если есть parentId, ищем родителя
                                if (currentElement.parentId) {
                                    const parent = findParent(currentElement.parentId, data);
                                    currentElement = parent;
                                } else {
                                    break; // Достигли корня
                                }
                            }
                            return null; // Таблица не найдена
                        }
                        const tableName = findTableName(this.state.menuList2, this.cldEl);   
                        console.log('del ind', tableName);                     
                        this.dispatch('Home','DeleteInd',this.cldEl,tableName)                        
                    }
                    // console.log('clicCtxMenu Refresh',this.state.active_tab.idconnect);
                    // this.getArr()
                    break;
                case 'Database info':
                    this.dispatch('Home','Database info',this.cldEl)
                    // console.log('clicCtxMenu Refresh',this.state.active_tab.idconnect);
                    // this.getArr()
                    break;
                case 'Create':
                    if (this.cldEl.type == 'lvl2') this.dispatch('Home','CreateTbl')
                    if (this.cldEl.type == 'lvl4') {
                        // console.log("crInd",this.cldEl);
                        // console.log("crInd",this.findParentById(this.cldEl.parentId, this.cldEl.parentType));
                        const search = (items) => {
                            for (const item of items) {
                                // Проверяем текущий элемент
                                // const itemId = this.getItemId(item)
                                // console.log('findInMenuStructure search',itemId); 
                                if (item.type === 'lvl3' && item.id === this.cldEl.parentId) {
                                    return item
                                }
                                
                                // Рекурсивно проверяем дочерние элементы
                                if (item.childs && item.childs.length > 0) {
                                    const found = search(item.childs)
                                    if (found) return found
                                }
                            }
                            return null
                        }
                        let item = search(this.state.menuList2)
                        console.log('clicCtxMenu create', item.name);
                        
                        this.dispatch('Home','CreateInd', item.name)}
                    // console.log('clicCtxMenu Refresh',this.state.active_tab.idconnect);
                    // this.getArr()
                    break;
                case 'Select top 1000':
                    this.dispatch('Home','Select top 1000',this.cldEl)
                    // console.log('clicCtxMenu Refresh',this.state.active_tab.idconnect);
                    // this.getArr()
                    break;
                case 'Modify structure':
                    this.dispatch('Home','Modify structure',this.cldEl)
                    // console.log('clicCtxMenu Refresh',this.state.active_tab.idconnect);
                    // this.getArr()
                    break;
                case 'Monitoring':
                    this.dispatch('Home','Monitoring')
                    // console.log('clicCtxMenu Refresh',this.state.active_tab.idconnect);
                    // this.getArr()
                    break;
                case 'Create table':
                    this.dispatch('Home','Create table',this.cldEl)
                default:
                    break;
            }
            this.showMenu = false;
            // let select = "SELECT TOP 1000 * FROM " + '['+this.source.tablename+']' + ";";
        },
        handleFilteredScroll() {
            // Дебаунсим вызовы чтобы избежать бесконечного цикла
            
            
            // this._scrollTimeout = setTimeout(() => {
                const searchText = this.filterText.trim().toLowerCase();
                const filteredStructure = this.buildFilteredStructure(searchText);
                this.renderFilteredMenu(filteredStructure);
            // }, 16); // ~60fps
        },
        getParentElement(childEl) {
            if (!childEl || !childEl.parentId || !childEl.parentType) {
                return null;
            }
            
            return this.findParentById(childEl.parentId, childEl.parentType);
        }
    }
}
</script>

<style lang="scss">
.elWrap {
    display: flex;
    width: 98%;
    flex-direction: column;
    justify-content: space-between;
    .jqx-scrollbar {
        // position: fixed;
        // top: 69px;
        // left: 13%;
    }
    .jqx-reset .jqx-scrollbar-state-normal {
        background: white;        
        width: 8px !important;
    }
    .jqx-scrollbar-thumb-state-normal {
        background: #848e96;
        border-radius: 13px;
        border: 0;
    }
    .jqx-scrollbar-button-state-normal{
        width: 8px;
        border: none;
    }
}
.v-list-item__title {
    font-size: 13px;
}
.v-list-item {
    min-height: 20px;
    cursor: pointer;
    padding: 0 10px;    
}
.v-list-item:hover {
    background: rgba(127,127,127,0.75);
    .v-list-item__title {
        color: white;
    }
}
.clkEl {
    background: rgba(127,127,127,0.75);
}
.darkTheme {
    background-color: rgb(20, 20, 20);
}
</style>